import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService, ToastService, UploadFileState } from '@siemens/ix-angular';
import { Subscription } from 'rxjs';
import { CrmtCommandSelectorComponent } from 'src/app/components/crmt-command-selector/crmt-command-selector.component';
import { CrmtDateSelectorComponent } from 'src/app/components/crmt-date-selector/crmt-date-selector.component';
import { CrmtDeviceSelectorComponent } from 'src/app/components/crmt-device-selector/crmt-device-selector.component';
import { ReviewKeyPair } from 'src/app/components/crmt-job-review/crmt-job-review.component';
import { ApiService, CommandJobRequest } from 'src/app/services/api.service';
import { NextBtnStateService } from 'src/app/services/next-btn-state.service';
import { PermissionsService, UserLevel } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-send-command-page',
  templateUrl: './send-command-page.component.html',
  styleUrls: ['./send-command-page.component.css']
})
export class SendCommandPageComponent implements OnInit {

  @ViewChild(CrmtCommandSelectorComponent) commandSelector?: CrmtCommandSelectorComponent
  public commandSelectorData?: any
  @ViewChild(CrmtDeviceSelectorComponent) deviceSelector?: CrmtDeviceSelectorComponent
  public deviceSelectorData?: any
  @ViewChild(CrmtDateSelectorComponent) dateSelector?: CrmtDateSelectorComponent
  public dateSelectorData?: any
  public errorMessage: string = "";
  @ViewChild('customModalForErrorMessage', { read: TemplateRef })
  customModalForErrorMessage!: TemplateRef<any>;
  
  public reviewData!: ReviewKeyPair[]
  public updateCommand = '';

  @ViewChild('customToast', { read: TemplateRef })
  customModalRef!: TemplateRef<any>;

  public state = UploadFileState.SELECT_FILE;
  public files: File[] = []
  public jobId: string = ""
  public selectedTab = 0
  public isError = false

  public status: string[] = [
    'open',
    'open',
    'open',
    'open'
  ]

  public selectedFile?: string
  public submitted = false
  public disableStandard = true
  public groupOrDeviceSelected = false;
  private subscription!: Subscription

  constructor(
    private readonly permissions: PermissionsService,
    private _apiService: ApiService,
    private readonly toastService: ToastService, 
    private nextBtnStateService: NextBtnStateService, 
    private router: Router,
    private readonly modalService: ModalService) {}
    
  ngOnInit(): void {

    this.permissions.getUserLevel().subscribe(level => {
      this.disableStandard = level < UserLevel.STANDARD
    })
  }
  
  public getCommandType(e: any) {
    this.updateCommand = e;
    this.status = ['open',
    'open',
    'open',
    'open'
  ];
    this.commandSelector?.clearData();
  }
  
  public deviceHandler(devices: string[]) {

    if(devices.length > 0) {
      this.status[1] = 'done'
    }
    else {
      this.status[1] = 'open'
    }
  }

  public statusHandler(event:any){
    this.groupOrDeviceSelected = event;
    if(!this.groupOrDeviceSelected){
      this.status = ['done',
        'open',
        'open',
        'open'
      ];
    }
    else{
      this.status[1] = 'done'
    }
  }

  public previous() {
    
    if(this.selectedTab > 0) {
      this.selectedTab--
    }
  }

  public navigation(selected: number) {
    if (!this.submitted) {
      if (this.selectedTab > selected) {
        this.selectedTab = selected;
      } else if ((this.selectedTab == 0 || this.selectedTab == 1 || this.selectedTab == 2)) {
        this.next()
      }
      if (this.status[selected - 1] == 'done' && this.selectedTab < selected) {
        this.selectedTab = selected - 1;
        this.next();
      }
    }
  }

  // TODO: This will be refactored in due course
  public next() {
    if(this.selectedTab == 0) {
      this.commandSelectorData = this.commandSelector?.getData()

      if(this.commandSelectorData?.done) {
        this.status[0] = 'done'
        this.incrementTab()
      }
      else {
        this.status[0] = 'error'
      }
    }
    else if(this.selectedTab == 1) {
      this.deviceSelectorData = this.deviceSelector?.getData();
      if(this.deviceSelectorData?.done && this.groupOrDeviceSelected) {
        this.status[1] = 'done'
        this.incrementTab()
      }
      else {
        this.status[1] = 'error'
        this.status[2] = 'open'
      }
    }
    else if(this.selectedTab == 2) {
      this.dateSelectorData = this.dateSelector?.getData()

      if(this.dateSelectorData?.done) {
        this.status[2] = 'done'

        this.reviewData = [
          { key: "Type", value: this.commandSelectorData?.type},
          this.deviceSelectorData.groupMode ? {
            key: "Groups", value: this.updateGroupNames(this.deviceSelectorData.groups).join(', ')
          } : { 
            key: "Devices", value: this.getDeviceStockNumber(this.deviceSelectorData?.devices).join(', ')
          },
          { key: "Schedule", value: this.dateSelectorData?.now ? 'Deploy now' : `Deploy later (${this.dateSelectorData.startTime})`},
          ];

        this.incrementTab()
      }
    }
    
    else if(this.selectedTab == 3) {
      this.submit()
      this.incrementTab()
    }
  }

  private getDeviceStockNumber(selection: string[]) {
    let deviceStockNumber: string[] = []
    selection.forEach((element: any) => {
      deviceStockNumber.push(element.engineNumber)
    });
    return deviceStockNumber
  }

  private updateGroupNames(strings: string[]): string[] {
    return strings.map(groupName => {
     var indexOfSpecialCharacter = groupName.indexOf(':')
     if (indexOfSpecialCharacter > 0) {
        return groupName.substring(indexOfSpecialCharacter + 1);
      } else {
        return groupName;
      }
   });
  }

  public sendAnotherCommand() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['send-command'])
    });
  }

  private incrementTab(): void {
    if(this.selectedTab < 4) {
      this.selectedTab++
    }
  }

  private submit() {
    this.status[3] = 'done'
    const file = this.commandSelectorData.file

    // Convert the GUI file type to an API file type
    const command = this.commandSelectorData.type;
    const groupMode = this.deviceSelectorData.groupMode
    const job: CommandJobRequest = {
      command,
      groups: groupMode ? this.deviceSelectorData?.groups : null,
      devices: groupMode ? null : this.getDeviceName(this.deviceSelectorData?.devices),
      scheduleLater: this.dateSelectorData?.now == false,
      startTime: this.dateSelectorData?.startTime,
      swVersion: parseInt(this.commandSelectorData.swVersion),
      stockType: this.commandSelectorData.stockType,
      stockNumber: this.commandSelectorData.stockNumber,
      languageCode: parseInt(this.commandSelectorData.languageCode)
    }

    return this._apiService.sendCommand(job).subscribe({
      next: (data) => {
        this.jobId = data.message.jobId
        this.showToastMessage()
        this.submitted = true
      },
      error: (e) => {
        if(e.status == 0){// This is the 0 = unknown Error
          this.errorMessage = "Unable to process your request. Please try again later or contact the administrator."
          this.openModalForErrorMessage()
        }else {
          this.errorMessage = `Error occurred while sending command. Please contact administrator.`
          this.openModalForErrorMessage()
        }
        this.submitted = false
        this.isError = true
        this.previous()
      }
    })
  }

  private getDeviceName(selection: string[]) {
    let deviceName: string[] = []
    selection.forEach((element: any) => {
      deviceName.push(element.name)
    });
    return deviceName
  }

  async showToastMessage() {
    this.toastService.setPosition('top-right');
    this.toastService.show({
      message: 'Deployment job submitted',
      type: "success",
      autoCloseDelay: 10000
    });
  }

  ngOnDestroy(): void {
    this.nextBtnStateService.setDisableNextBtn(true)
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async openModalForErrorMessage() {
    const instance = await this.modalService.open({
      content: this.customModalForErrorMessage
    })
    instance.htmlElement.addEventListener('keydown',(keyboardEvent: KeyboardEvent) => {});
  }
}
